<template>
	<div class="header" :titles=titles>
		<div class="first-bar-wrapper">
			<div class="first-bar-left">
				<a href="http://www.1shitou.com/system/zhizunvip.html" target="_blank">麟龙至尊套餐用户专区</a>
				<!-- <span>展开</span> -->
			</div>
			<div class="first-bar-right">
				<span>您好！欢迎来到石头网</span>
				<a href="javascript:;" v-show="!isLogin" @click="loginPoup">立即登录</a>
				<a href="/personalCenter/editIndex.html" v-show="isLogin">{{userName}}</a>
				<!-- <a href="/login/register.html" v-show="!isLogin">免费注册</a> -->
				<a href="javascript:;" v-show="!isLogin" @click="registerPoup">免费注册</a>
				<a href="javascript:void(0);"  v-show="isLogin" @click="logOut">退出</a>
				<!--<a href="">APP</a>
				<a href="">微信</a>
				<a href="">股市直播</a>-->
				<a href="http://www.linlongtougu.com">麟龙投顾</a>
				<a href="https://www.jinjiwo.com/">基金开户</a>
				<a target="_blank" href="/softIndex/softIndex.html">软件购买</a>
			</div>
		</div>
		<div class="second-bar-wrapper">
			<a :href="stockUrl">
				<img src="/static/logo.png"/>
			</a>
			<div class="search-wrapper">
				<search></search>
				<div class="hot-search-wrapper">
					<a v-for="item in hotWords" :href="item.link">{{item.title}}</a>
				</div>
			</div>
			<div class="download-code-box">
				<img src="/static/downloda_code.png" alt="code">
			</div>
			<div class="tel-wrapper">
				021-51091601(客服电话)
                <br/>
                021-51091621(投诉电话)
                <div style="font-size: 10px;font-weight: 700;">
                    工作日9:00-11:30,13:00-18:00
                </div>
			</div>
		</div>
		<div class="navigation-wrapper" :class="{'hover-bg':isHover}">
			<div class="navigation">
				<div class="navigation-left" @mouseover="changeNavBg" @mouseout="changeNavBgNormal">
					<a :href="stockUrl">首页</a>
					<a :href="stockUrl+'live.html?index=0'">客户讲堂</a>
					<!-- <a href="https://www.jinjiwo.com/" target="_blank">基金</a> -->
					<!-- <a href="/channel/channelList.html?index=2" :class="{'active':!isActive}">股票</a> -->
					<a :href="stockUrl+'video/area?columnId=23&index=3'" :class="{'softActive':isShow==4}" @mouseover="showList(4)" @mouseout="hideList(4)">学堂</a>
					<a :href="stockUrl+'topic/index?index=4'">专栏热点</a>
					<a href="/famousInvestor/famousInvestor.html?index=2">名家系列</a>
					<a :href="stockUrl+'video/area?columnId=42&index=5'" :class="{'softActive':isShow==6}" @mouseover="showList(6)" @mouseout="hideList(6)">麟龙专区</a>
					<!-- <a href="/softIndex/softIndex.html?index=6" :class="{'active':isActive,'softActive':isShow==7}" @mouseover="showList(7)" @mouseout="hideList(7)">软件服务</a> -->
					<a href="/softIndex/softIndex.html?index=6" :class="{'active':isActive}">软件服务</a>
					<a :href="stockUrl+'video/area?columnId=76&index=7'">新三板</a>
					<a href="/aboutLinLongSecond/aboutUs.html?index=8">关于麟龙</a>
				</div>
				<div class="navigation-right" @mouseover="changeNavBg" @mouseout="changeNavBgNormal">
					<!--<a href="">保险</a>
					<a href="">贵金属</a>
					<a href="">外汇</a>
					<a href="">期货</a>
					<a href="">私募</a>
					<a href="">期货</a>-->
					<!-- <a href="https://www.jinjiwo.com/" target="_blank">基金</a> -->
				</div>
			<!-- <transition name="fade">
			    <div class="nav-detail-box" v-if="isShow==7" @mouseover="showList(7)" @mouseout="hideList(7)">
			    	<div class="nav-detail-contain">
			    		<ul>
			    		<li>
			    			<div>麟龙软件</div>
			    			<ul>
			    				<li><a href="/softService/oldProduct.html?version=0">普及版</a></li>
			    				<li><a href="/softService/oldProduct.html?version=1">专业版</a></li>
			    				<li><a href="/softService/oldProduct.html?version=2">至尊版</a></li>
			    				<li><a href="/softService/oldProduct.html?version=3">至尊套餐</a></li>
			    			</ul>
			    		</li>
			    		<li>
			    			<div>期天大胜</div>
			    			<ul>
			    				<li><a href="/softService/qtdsProduct.html?version=1">机构版</a></li>
			    				<li><a href="/softService/qtdsProduct.html?version=0">专业版</a></li>
			    			</ul>
			    		</li>
			    		<li class="item-specail">
			    			<div>新版麟龙软件</div>
			    			<ul>
			    				<li><a href="/softService/newProduct.html?version=0">普及版</a></li>
			    				<li><a href="/softService/newProduct.html?version=1">专业版</a></li>
			    				<li><a href="/softService/newProduct.html?version=2">至尊版</a></li>
			    				<li><a href="/softService/newProduct.html?version=3">至尊套餐</a></li>
			    				<li><a href="/softService/newProduct.html?version=4">科技至尊套餐</a></li>
			    			</ul>
			    		</li>
			    		<li>
			    			<div>如来神涨App</div>
			    			<ul>
			    				<li><a href="/softService/rlszProduct.html">科技经典版</a></li>
			    			</ul>
			    		</li>
			    		<li>
			    			<div>龙周刊</div>
			    			<ul>
			    				<li><a href="/softTg/longProduct.html?version=0">黄金版</a></li>
			    				<li><a href="/softTg/longProduct.html?version=1">铂金版</a></li>
			    				<li><a href="/softTg/longProduct.html?version=2">钻石版</a></li>
			    			</ul>
			    		</li>
			    	</ul>
			    	<div>
			    		<img src="/static/soft_index/ads.jpg"/>
			    	</div>
			    	</div>
			    </div>
			    </transition> -->
				<transition name="fade">
			    <div class="nav-detail-box" v-if="isShow==4" @mouseover="showList(4)" @mouseout="hideList(4)">
			    	<div class="nav-detail-contain">
			    		<ul>
			    		<li>
			    			<div><a :href="stockUrl+'video/area?columnId=23&index=3'">股票</a></div>
			    			<ul>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=24'">技术分析</a></li>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=25'">基本分析</a></li>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=26'">专题教学</a></li>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=27'">系列教学</a></li>
			    			</ul>
			    		</li>
						<li>
			    			<div><a :href="stockUrl+'video/area?columnId=28&index=3'">公募学堂</a></div>
			    			<ul>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=29'">基金介绍</a></li>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=30&columnId=32'">基金知识</a></li>
			    			</ul>
			    		</li>
						<li>
			    			<div><a :href="stockUrl+'video/area?columnId=35&index=3'">私募基金</a></div>
			    			<ul>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=36'">基金介绍</a></li>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=37&columnId=39'">基金知识</a></li>
			    			</ul>
			    		</li>
						<li>
			    			<div><a :href="stockUrl+'video/area?columnId=19&index=3'">股指期货</a></div>
			    			<ul>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=20'">基础知识</a></li>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=21'">实战技巧</a></li>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=22'">特色指标教学</a></li>
			    			</ul>
			    		</li>
						<li>
			    			<div><a :href="stockUrl+'video/area?columnId=12&index=3'">商品期货</a></div>
			    			<ul>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=13'">期货品种介绍</a></li>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=14&columnId=17'">期货知识</a></li>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=15'">对冲组合</a></li>
			    			</ul>
			    		</li>
						<li>
			    			<div><a :href="stockUrl+'video/area?columnId=1&index=3'">其他</a></div>
			    			<ul>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=2&columnId=5'">保险</a></li>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=3&columnId=8'">外汇</a></li>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=4&columnId=10'">黄金</a></li>
			    			</ul>
			    		</li>
			    	</ul>
			    	<div>
			    		<img src="/static/soft_index/study_ad1.jpg"/>
			    	</div>
					<!-- <div>
			    		<img src="/static/soft_index/study_ad1.jpg"/>
			    	</div> -->
			    	</div>
			    </div>
			    </transition>
				<transition name="fade">
			    <div class="nav-detail-box" v-if="isShow==6" @mouseover="showList(6)" @mouseout="hideList(6)">
			    	<div class="nav-detail-contain">
						<ul>
			    		<li  class="item-specail">
			    			<div><a  :href="stockUrl+'video/area?columnId=42&index=5'">麟龙软件</a></div>
			    			<ul>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=77'">体验专区</a></li>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=43&columnId=47'">普及版</a></li>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=44&columnId=50'">专业版</a></li>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=45&columnId=53'">至尊版</a></li>
								<li><a :href="stockUrl+'video/listPage?mainColumnId=46&columnId=57'">麟龙套餐课程</a></li>
			    			</ul>
			    		</li>
						<li>
			    			<div><a  :href="stockUrl+'video/area?columnId=58&index=5'">期天大胜</a></div>
			    			<ul>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=78'">体验专区</a></li>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=60&columnId=67'">专业版</a></li>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=61&columnId=71'">机构版</a></li>
			    				<li><a :href="stockUrl+'video/listPage?mainColumnId=62&columnId=63'">期指期货实战班</a></li>
			    			</ul>
			    		</li>
						</ul>
						<div>
			    		<img src="/static/soft_index/study_ad2.jpg"/>
			    	</div>
					<div>
			    		<img src="/static/soft_index/study_ad1.jpg"/>
			    	</div>
			    		<!-- <ul class="sub-ul">
			    		<li class="hasThirdSubItem">
			    			<div>麟龙软件</div>
			    			<ul>
			    				<li class="hasThirdSub">
									<a :href="stockUrl+'video/listPage?mainColumnId=77&index=4'">体验专区</a>
								</li>
			    				<li class="hasThirdSub">
									<a :href="stockUrl+'video/listPage?mainColumnId=43&columnId=47&index=4'">普及版</a>
									<ul>
										<li><a :href="stockUrl+'video/listPage?mainColumnId=43&columnId=47&index=4'">基本功能课</a></li>
										<li><a :href="stockUrl+'video/listPage?mainColumnId=43&columnId=48&index=4'">指标讲解课</a></li>
										<li><a :href="stockUrl+'video/listPage?mainColumnId=43&columnId=49&index=4'">特色指标应用课</a></li>
									</ul>
								</li>
								<li class="hasThirdSub">
									<a :href="stockUrl+'video/listPage?mainColumnId=44&columnId=50&index=4'">专业版</a>
									<ul>
										<li><a :href="stockUrl+'video/listPage?mainColumnId=44&columnId=50&index=4'">基本功能课</a></li>
										<li><a :href="stockUrl+'video/listPage?mainColumnId=44&columnId=51&index=4'">指标讲解课</a></li>
										<li><a :href="stockUrl+'video/listPage?mainColumnId=44&columnId=52&index=4'">特色指标应用课</a></li>
									</ul>
								</li>
								<li class="hasThirdSub">
									<a :href="stockUrl+'video/listPage?mainColumnId=45&columnId=53&index=4'">至尊版</a>
									<ul>
										<li><a :href="stockUrl+'video/listPage?mainColumnId=45&columnId=53&index=4'">至尊必修课</a></li>
										<li><a :href="stockUrl+'video/listPage?mainColumnId=45&columnId=54&index=4'">基本功能课</a></li>
										<li><a :href="stockUrl+'video/listPage?mainColumnId=45&columnId=55&index=4'">指标讲解课</a></li>
										<li><a :href="stockUrl+'video/listPage?mainColumnId=45&columnId=56&index=4'">特色指标应用课</a></li>
									</ul>
								</li>
								<li class="hasThirdSub">
									<a :href="stockUrl+'video/listPage?mainColumnId=46&columnId=57&index=4'">麟龙套餐课程</a>
								</li>
			    			</ul>
			    		</li>
			    		<li class="hasThirdSubItem">
			    			<div>期天大胜</div>
			    			<ul>
			    				<li class="hasThirdSub">
									<a :href="stockUrl+'video/listPage?mainColumnId=78&index=4'">体验专区</a>
								</li>
			    				<li class="hasThirdSub">
									<a :href="stockUrl+'video/listPage?mainColumnId=60&columnId=67&index=4'">专业版</a>
									<ul>
										<li><a :href="stockUrl+'video/listPage?mainColumnId=60&columnId=67&index=4'">基本功能课</a></li>
										<li><a :href="stockUrl+'video/listPage?mainColumnId=60&columnId=68&index=4'">指标讲解课</a></li>
										<li><a :href="stockUrl+'video/listPage?mainColumnId=60&columnId=69&index=4'">特色指标应用课</a></li>
									</ul>
								</li>
								<li class="hasThirdSub">
									<a :href="stockUrl+'video/listPage?mainColumnId=60&columnId=67&index=4'">机构版</a>
									<ul>
										<li><a :href="stockUrl+'video/listPage?mainColumnId=61&columnId=70&index=4'">基本功能课</a></li>
										<li><a :href="stockUrl+'video/listPage?mainColumnId=61&columnId=71&index=4'">指标讲解课</a></li>
										<li><a :href="stockUrl+'video/listPage?mainColumnId=61&columnId=72&index=4'">特色指标应用课</a></li>
									</ul>
								</li>
								<li class="hasThirdSub">
									<a :href="stockUrl+'video/listPage?mainColumnId=62&columnId=63&index=4'">期指期货实战班</a>
								</li>
			    			</ul>
			    		</li>
			    	</ul> -->
			    	</div>
			    </div>
			    </transition>
			    <!-- <transition name="fade">
			    	<div class="study-box" v-if="isShow==4" @mouseover="showList(4)" @mouseout="hideList(4)">
			    		<ul class="study-subpage-box">
					    	<li><a :href="stockUrl+'video/index?columnId=536313e87f6542fd8c3caf82df05f6c3&index=3'">基金学堂</a></li>
					    	<li><a :href="stockUrl+'video/index?columnId=0e4f3509ce6240c68b18229779fef545&index=3'">股票学堂</a></li>
					    </ul>
			    	</div>
			    </transition> -->
			    <!-- <transition name="fade">
			    	<div class="lilong-box" v-if="isShow==5" @mouseover="showList(5)" @mouseout="hideList(5)">
			    		<ul class="study-subpage-box">
					    	<li><a :href="stockUrl+'video/area?columnId=42&index=4'">麟龙软件</a></li>
					    	<li><a :href="stockUrl+'video/area?columnId=58&index=4'">期天大胜</a></li>
					    </ul>
			    	</div>
			    </transition> -->
			</div>
		</div>
		<div class="header fixed-header">
			<div class="cwrap">
				<div class="logo">
					<a :href="stockUrl"><img src="/static/login/login_logo.png" alt=""></a>
				</div>
				<ul class="nav" id="fixNavigation">
					<li>
						<a :href="stockUrl" class="m-nav">首页</a>
					</li>
					<li>
						<a :href="stockUrl+'live.html?index=0'" class="m-nav">客户讲堂</a>
					</li>
					<!-- <li>
						<a :href="foundUrl+'/fundchannel/index.html?index=1'" class="m-nav">基金</a>
					</li> -->
					<!-- <li>
						<a href="/index.html?index=2" class="m-nav">股票</a>
					</li> -->
					<li>
						<a :href="stockUrl+'video/area?columnId=23&index=3'" class="m-nav">学堂</a>
					</li>
					<li>
						<a :href="stockUrl+'topic/index?index=4'" class="m-nav">专栏热点</a>
					</li>
					<li>
						<a href="/famousInvestor/famousInvestor.html?index=2" class="m-nav">名家系列</a>
					</li>
					<li>
						<a :href="stockUrl+'video/area?columnId=42&index=5'" class="m-nav">麟龙专区</a>
					</li>
					<li>
						<a href="/softIndex/softIndex.html?index=6" class="m-nav">软件服务</a>
					</li>
					<li>
						<a :href="stockUrl+'video/area?columnId=76&index=7'" class="m-nav">新三板</a>
					</li>
					<li>
						<a href="/aboutLinLongSecond/aboutUs.html?index=8" class="m-nav">关于麟龙</a>
					</li>
				</ul>
				<div class="head-search">
				   <search-fixed></search-fixed>
				</div>
				<div class="my-account-link">
					<a class="my-account-noLogin" href="javascript:;" v-show="!isLogin" @click="loginPoup">我的账户</a>
					<a class="my-account-isLogin" href="/personalCenter/editIndex.html" v-show="isLogin">我的账户</a>
				</div>
			</div>
		</div>
		<!-- login register poup -->
		<el-dialog
		    custom-class="myDialog"
			:visible.sync="dialogVisible"
			top="20vh"
			:close-on-click-modal='dialogFalse'
			:close-on-press-escape='dialogFalse'
			width="460px"
			@close="clearFormFn"
			>
			<component :is="componentName" :clearform="clearForm" @poupwhich="changePoup" @getuserinfo="getUserInfo" @closepoup="closePoup1"></component>
		</el-dialog>
		<el-dialog
		    custom-class="myDialog1"
			:visible.sync="dialogVisible1"
			top="40vh"
			:close-on-click-modal='dialogFalse'
			:close-on-press-escape='dialogFalse'
			width="360px"
			@close="closePoup"
			>
			<login-out @logouthide="dialogVisible1=false"></login-out>
		</el-dialog>
	</div>
</template>

<script type="text/ecmascript-6">
import search from 'common/search';
import searchFixed from 'common/searchfixed';
import registerPoup from 'common/registerPoup';
import loginPoup from 'common/loginPoup';
import bindTelPoup from 'common/bindTelPoup';
import noticePoup from 'common/noticePoup';
import loginOut from 'common/loginOut';
	export default{
        props: {
			titles: '',
			poupvisible:{
				type:Boolean
			}
        },
		data(){
			return {
				dialogVisible: false,
				dialogVisible1: false,
				dialogFalse:false,
				componentName:'registerPoup',
				loginType:'',
				isLogin:false,
				userName:'',
				mobileNumber:'',
				email:'',
				lastLoginTime:null,
				access_token:'',
				refresh_token:'',
				isRequested:false,
				currentUrl:window.location.href,
				stockUrl:window.stockUrl,
				hotWords:[],
				isShow:0,
				isActive:false,
				isHover:false,
				clearForm:false
            };
		},
		components:{search,searchFixed,registerPoup,loginPoup,bindTelPoup,noticePoup,loginOut},
		created:function(){
			if(this.currentUrl.indexOf('soft')!=-1){
				this.isActive=true;
			}else{
				this.isActive=false;
			}
		},
		watch:{
        	isRequested:function(newValue,oldValue){
        		if(newValue){
        			this.$emit('datachange',[this.userName,this.mobileNumber,this.email,this.lastLoginTime]);
        		}
			},
			poupvisible:function(newValue,oldValue){
				if (newValue&&newValue!=oldValue) {
					this.dialogVisible1=true;
				}
			}
        },
        mounted: function () {
        	var index=this.getUrlParamsByKey(this.currentUrl,'index')?this.getUrlParamsByKey(this.currentUrl,'index')-0:null;
        	window.addEventListener('scroll', this.handleScroll);
			  //check login or logout
          	this.loginType=this.cookies().read('login_type');
          	this.access_token= this.cookies().read('access_token');
			this.refresh_token= this.cookies().read('refresh_token');
			if (this.loginType==='mobile'||(this.loginType==='username'&&this.cookies().read('mobile'))) {
				this.isLogin=true;
				this.getUserInfo();
			}else if (this.loginType==='username'&&!this.cookies().read('mobile')){
				this.cookies().del('login_type');
				this.cookies().del('access_token');
				this.cookies().del('refresh_token');
				this.cookies().del('username');
				this.cookies().del('id');
		        this.cookies().del('last_login_time');
			}
            if(this.titles == 'aboutUs'){
                $('.navigation-left a').removeClass('active');
                $('.navigation-left a').eq(6).addClass('active');
            }
            if (index==0||index) {
				$('.navigation-left a').removeClass('active');
				switch (index) {
					case 0:
						$('.navigation-left a').eq(1).addClass('active');
						break;
				    case 3:
						$('.navigation-left a').eq(2).addClass('active');
						break;
					case 4:
						$('.navigation-left a').eq(3).addClass('active');
						break;
					case 2:
						$('.navigation-left a').eq(4).addClass('active');
						break;
					case 5:
						$('.navigation-left a').eq(5).addClass('active');
						break;
					case 6:
						$('.navigation-left a').eq(6).addClass('active');
						break;
					case 7:
						$('.navigation-left a').eq(7).addClass('active');
						break;
					case 8:
						$('.navigation-left a').eq(8).addClass('active');
						break;
					default:
						break;
				}
			}
			// else{
			// 	 $('.navigation-left a').eq(0).addClass('active');
			// }
            this.getActiveColor();
            this.getHotWords();
        },
        destroyed () {
		  window.removeEventListener('scroll', this.handleScroll)
		},
        methods:{
        	handleScroll () {
			  var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			  var offsetTop = 86;
			  if (this.currentUrl.indexOf('softService')!=-1 ||this.currentUrl.indexOf('softTg')!=-1) {
			  	$('.fixed-header').slideUp(0);
			  	return false;
			  }
			  if (scrollTop > offsetTop) {
			    $('.fixed-header').slideDown(0);
			  } else {
			    $('.fixed-header').slideUp(0);
			  }
			},
        	getActiveColor:function(){
        		var index=$('.navigation-left a.active').index();
        		$('.nav li').removeClass('active').eq(index).addClass('active');
        	},
        	getUserInfo:function(){
				var _this = this;
				var opts = {
					isLoading: true,
					loadingDom: '',
					success: function(result) {
						if (result.path.indexOf('getProfile')!=-1) {
							_this.isRequested=true;
						    _this.isLogin=true;
							_this.mobileNumber=result.content.mobileNumber?result.content.mobileNumber:'手机号暂未绑定';
							_this.email=result.content.email?result.content.email:'邮箱暂未绑定';
							_this.lastLoginTime=result.content.lastLoginTime?result.content.lastLoginTime.toString():'';
							if (_this.cookies().read('saveEmail')&&_this.cookies().read('saveEmail')!=_this.email) {
								_this.cookies().write('saveEmail',_this.email, 7);
							}
							if (_this.cookies().read('last_login_time')!=_this.lastLoginTime) {
								if (result.content.lastLoginTime) {
									_this.cookies().write('last_login_time',result.content.lastLoginTime, 7);
								} else {
									_this.cookies().write('last_login_time','', 7);
								}
							}
							if (_this.cookies().read('username')!=result.content.username) {
								_this.cookies().write('username',result.content.username, 7);
							}
							if (_this.cookies().read('id')!=result.content.id) {
								_this.cookies().write('id',result.content.id, 7);
							}
							if (result.content.mobileAuthLocked) {
								if (!_this.cookies().read('mobileAuthLocked')||(_this.cookies().read('mobileAuthLocked')&&_this.cookies().read('mobileAuthLocked')!=(result.content.mobileAuthLocked).toString())) {
									_this.cookies().write('mobileAuthLocked',result.content.mobileAuthLocked, 7);
								}
							} else {
								_this.cookies().write('mobileAuthLocked','null', 7);
							}
							if (_this.cookies().read('mobile')!=_this.mobileNumber) {
									_this.cookies().write('mobile',_this.mobileNumber, 7);
								}
							// if (result.content.mobileNumber) {
							// 	if (_this.cookies().read('mobile')!=_this.mobileNumber) {
							// 		_this.cookies().write('mobile',_this.mobileNumber, 7);
							// 	}
							//    _this.isLogin=true;
							// } else {
							// 	_this.isLogin=false;
							// 	_this.dialogVisible=true;
							// 	_this.componentName='bindTelPoup';
							// 	return false;
							// }

							if (_this.loginType=='mobile') {
								_this.userName=result.content.mobileNumber.substr(0,3)+'****'+result.content.mobileNumber.substr(7);
							} else if (_this.loginType=='username'){
								_this.userName=result.content.username;
							}
							_this.$emit('datachange',[_this.userName,_this.mobileNumber,_this.email,_this.lastLoginTime]);

						} else{
							_this.cookies().write('access_token',result.content.access_token);
							_this.cookies().write('refresh_token',result.content.refresh_token);
							_this.access_token=result.content.access_token;
							_this.refresh_token=result.content.refresh_token;
							_this.getAjaxCommon(accountBaseUrl+'/account/getProfile','get',{accessToken:_this.access_token},opts);
						}
					},
					getNewAccessToken:function(){
						_this.getAjaxCommon(accountBaseUrl+'/account/refreshToken','post',{refreshToken:_this.refresh_token},opts);
					},
					jumpToLogin:function(){
						_this.isLogin=false;
						_this.loginType='';
						_this.userName='';
						_this.access_token='';
						_this.refresh_token='';
						_this.cookies().del('last_login_time');
						_this.cookies().del('saveEmail');
						_this.cookies().del('mobile');
						_this.cookies().del('username');
						_this.cookies().del('login_type');
						_this.cookies().del('access_token');
						_this.cookies().del('refresh_token');
						_this.cookies().del('id');
						_this.cookies().del('mobileAuthLocked');
						// 弹出互踢弹窗
					    _this.dialogVisible1=true;
					},
					error:function(result){
						_this.isLogin=false;
						_this.loginType='';
						_this.userName='';
						_this.access_token='';
						_this.refresh_token='';
						_this.cookies().del('last_login_time');
						_this.cookies().del('saveEmail');
						_this.cookies().del('mobile');
						_this.cookies().del('username');
						_this.cookies().del('login_type');
						_this.cookies().del('access_token');
						_this.cookies().del('refresh_token');
						_this.cookies().del('id');
						_this.cookies().del('mobileAuthLocked');
						console.log(result.message);
						// _this.$message({
						// 	showClose: true,
						// 	message: result.message,
						// 	type: 'warning'
						// });
					}
				};
				_this.loginType=_this.cookies().read('login_type') ? _this.cookies().read('login_type') : '';
				_this.access_token= _this.cookies().read('access_token') ? _this.cookies().read('access_token') : '';
			    _this.refresh_token= _this.cookies().read('refresh_token') ? _this.cookies().read('refresh_token') : '';
				_this.getAjaxCommon(accountBaseUrl+'/account/getProfile','get',{accessToken:_this.access_token},opts);
			},
			logOut:function(){
				var _this = this;
				var opts = {
					isLoading: true,
					loadingDom: '',
					success: function(result) {
						if (!result.path) {
							_this.isLogin=false;
							_this.access_token='';
							_this.refresh_token='';
							_this.cookies().del('last_login_time');
							_this.cookies().del('saveEmail');
							_this.cookies().del('username');
							_this.cookies().del('mobile');
							_this.cookies().del('login_type');
							_this.cookies().del('access_token');
							_this.cookies().del('refresh_token');
							_this.cookies().del('id');
							_this.cookies().del('mobileAuthLocked');
							if (_this.currentUrl!=_this.stockUrl) {
								window.location.href=_this.stockUrl;
							}
						} else if (result.path&&result.path.indexOf('/oauth/token')!=-1) {
							_this.cookies().write('access_token',result.content.access_token);
							_this.cookies().write('refresh_token',result.content.refresh_token);
							_this.access_token=result.content.access_token;
							_this.refresh_token=result.content.refresh_token;
							_this.getAjaxCommon(accountBaseUrl+'/account/logout','post',{accessToken:_this.access_token},opts);
						}
					},
					getNewAccessToken:function(){
						_this.getAjaxCommon(accountBaseUrl+'/account/refreshToken','post',{refreshToken:_this.refresh_token},opts);
					},
					jumpToLogin:function(){
						//无效的refresh_token,跳到首页
						_this.isLogin=false;
						_this.loginType='';
						_this.userName='';
						_this.access_token='';
						_this.refresh_token='';
						_this.cookies().del('last_login_time');
						_this.cookies().del('saveEmail');
						_this.cookies().del('mobile');
						_this.cookies().del('username');
						_this.cookies().del('login_type');
						_this.cookies().del('access_token');
						_this.cookies().del('refresh_token');
						_this.cookies().del('id');
						_this.cookies().del('mobileAuthLocked');
						if (_this.currentUrl!=_this.stockUrl) {
							window.location.href=_this.stockUrl;
						}
					},
					error:function(result){
						_this.isLogin=false;
						_this.loginType='';
						_this.userName='';
						_this.access_token='';
						_this.refresh_token='';
						_this.cookies().del('last_login_time');
						_this.cookies().del('saveEmail');
						_this.cookies().del('mobile');
						_this.cookies().del('username');
						_this.cookies().del('login_type');
						_this.cookies().del('access_token');
						_this.cookies().del('refresh_token');
						_this.cookies().del('id');
						_this.cookies().del('mobileAuthLocked');
						console.log(result.message);
						// _this.$message({
						// 	showClose: true,
						// 	message: result.message,
						// 	type: 'warning'
						// });
					}
				};
				_this.getAjaxCommon(accountBaseUrl+'/account/logout','post',{accessToken:_this.access_token},opts);
				return false;
			},
        	getHotWords:function(){
        		var $this=this;
        		var opts={
		    	 	isLoading:true,
		    	 	loadingDom:'',
		    	 	success:function(result){
		    	 		if (typeof result.data=='string') {
		    	 			result.data=JSON.parse(result.data);
		    	 		}
		    	 		if (result.data && result.data.data && result.data.data[0].length) {
		    	 				result.data.data[0].forEach(function(value,index){
		    	 					if (value.title) {
		    	 						$this.hotWords.push(value);
		    	 					}
		    	 				});
		    	 		}
		    	 	}
    	 		};
                $this.getAjaxCom('crm/getHomeHotWorldCrm','get','',opts);
        	},
        	showList(index){
        		this.isShow=index-0;
        	},
        	hideList(index){
        		this.isShow=0;
			},
			changeNavBgNormal(){
				this.isHover=false;
			},
			changeNavBg(){
				this.isHover=true;
			},
			bindTelPoup(){ //弹出绑定手机号
				this.dialogVisible = true;
				this.componentName='bindTelPoup';
			},
			loginPoup(){ //弹出登录
			    this.$nextTick(function(){
					this.dialogVisible = true;
					this.componentName='loginPoup';
				});
				// this.componentName='loginOut';
			},
			registerPoup(){ //弹出注册
				this.dialogVisible = true;
                this.componentName='registerPoup';
			},
			changePoup(param){
				var $this=this;
				$this.dialogVisible=false;
				if (param) {
					setTimeout(function(){
						$this.componentName=param;
						$this.dialogVisible=true;
					},500);
				}
			},
			closePoup(){
				this.dialogVisible1=false;
				if (this.currentUrl!=this.stockUrl) {
					window.location.href=this.stockUrl;
				}
			},
			closePoup1(){
				this.dialogVisible=false;
				if (this.currentUrl!=this.stockUrl) {
					window.location.href=this.stockUrl;
				}
			},
			clearFormFn(){
				this.clearForm=!this.clearForm;
			}
        }
	}
</script>
<style lang="scss">
@import "~scss/mixin";
	div.myDialog{
		    @include  borderradius(0);
			border: 7px solid rgba(255, 255, 255, .3);
			background: none;
			div.el-dialog__header{
				padding: 0;
				.el-dialog__headerbtn{
					top: 15px;
					right: 15px;
					z-index: 100;
					.el-dialog__close {
						color: #c2c2c2;
						font-size: 26px;
					}
					&:focus,
					&:hover {
						.el-dialog__close {
							color: $hover-color;
						}
					}
					}

			}
			div.el-dialog__body{
				color: #333333;
				padding: 0;
			}
	}
	div.myDialog1{
			@include  borderradius(10px);
			padding-top: 61px;
			height: 235px;
			div.el-dialog__header{
				padding: 0;
				.el-dialog__headerbtn{
					top: 15px;
					right: 15px;
					z-index: 100;
					.el-dialog__close {
						color: #999999;
						font-size: 20px;
					}
					&:focus,
					&:hover {
						.el-dialog__close {
							color: $hover-color;
						}
					}
					}

			}
			div.el-dialog__body{
				color: #333333;
				padding: 0 0 30px;
			}
	}
</style>
<style lang="scss" scoped="scoped">
@import '~scss/mixin';
	* {
		margin: 0;
		padding: 0;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
		-ms-tap-highlight-color: rgba(0, 0, 0, 0);
		tap-highlight-color: rgba(0, 0, 0, 0);
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		-ms-box-sizing: border-box;
		box-sizing: border-box;
		-ms-text-size-adjust: 100%;
		-webkit-text-size-adjust: 100%;
	}
   div.header{
    line-height: 1;
   	width: 100%;
   	background-color: #FFFFFF;
   	*zoom: -1;
   		position: relative;
   		@include clearboth;
   	div.first-bar-wrapper{
   		background-color: #f2f2f2;
   		overflow: hidden;
   		padding: 12px 35px 12px 0;
   		height: 37px;
   		font-size:14px;
   		color:#666666;
		position: relative;
   		div.first-bar-left{
   			position: absolute;
			width: 1200px;
			left: 50%;
			margin-left: -600px;
   			a{
   				display: inline-block;
   				// padding-right: 22px;
   				// padding-left: 22px;
   				-webkit-transition: color .4s;
   				-moz-transition: color .4s;
   				-ms-transition: color .4s;
   				-o-transition: color .4s;
   				transition: color .4s;
				   &+a{
					   border-left: 1px solid #dddddd;
				   }
   				&:hover{
   					color: #ff3d42;
   					-webkit-transition: color .4s;
	   				-moz-transition: color .4s;
	   				-ms-transition: color .4s;
	   				-o-transition: color .4s;
	   				transition: color .4s;
   				}
   			}
   			span{
   				display: inline-block;
   				padding-right: 19px;
   				background: url(~images/icon_menu.png) no-repeat right  center;
   			}
   		}
   		div.first-bar-right{
   			float: right;
			position: relative;
			z-index: 10;
   			span{
				vertical-align: top;
   				display: inline-block;
   			}
   			a{
   				display: inline-block;
   				margin-left: 20px;
   				padding-left: 20px;
   				border-left: 1px solid #dddddd;
   				color:#666666;
   				max-width: 105px;
   				overflow: hidden;
   				white-space: nowrap;
   				text-overflow: ellipsis;
   				-webkit-transition: color .4s;
   				-moz-transition: color .4s;
   				-ms-transition: color .4s;
   				-o-transition: color .4s;
   				transition: color .4s;
   				&:hover{
   					color: #ff3d42;
   					-webkit-transition: color .4s;
	   				-moz-transition: color .4s;
	   				-ms-transition: color .4s;
	   				-o-transition: color .4s;
	   				transition: color .4s;
   				}
   			}
   		}
   	}
   	div.second-bar-wrapper{
   		width: 1200px;
   		margin: 0 auto;
   		padding-top: 21px;
   		padding-bottom: 9px;
   		*zoom: -1;
   		position: relative;
   		&:after{
   			display: block;
   			content: '';
   			width: 0;
   			height: 0;
   			overflow: hidden;
   			visibility: hidden;
   			font-size: 0;
   			clear: both;
   		}
   		a{
   			img{
   				float: left;
   				margin-right: 123px;
   			}
   		}
   		div.search-wrapper{
   			float: left;
   			width: 489px;
   			div.hot-search-wrapper{
   				height: 25px;
   				padding-top: 11px;
   				overflow: hidden;
   				padding-left: 16px;
   				a{
   					display: inline-block;
   					float: left;
   					margin-right: 10px;
   					color: #999999;
   					-webkit-transition: color .4s;
					-moz-transition: color .4s;
					-ms-transition: color .4s;
					-o-transition: color .4s;
					transition: color .4s;
   					&:first-child{
   						color: #ff3c42;
   					}
   					&:last-child{
   						margin-right: 0;
   					}
   					&:hover{
   						color: #ff3c42;
   						-webkit-transition: color .4s;
						-moz-transition: color .4s;
						-ms-transition: color .4s;
						-o-transition: color .4s;
						transition: color .4s;
   					}
   				}
   			}
   		}
   		div.tel-wrapper{
   			float: right;
   			width: 250px;
   			background: url(~images/icon_tel.png) no-repeat left  center;
   			/*text-align: right;*/
   			padding-left: 42px;
   			font-size: 16px;
   			font-weight: bold;
   			color: #ff3c42;
   			line-height: 25px;

   		}
	    div.download-code-box{
			float: right;
   			width: 120px;
            text-align: center;
			margin-left: 48px;
			margin-top: -10px;
			img{
				width: 100%;
			}
		}
   	}
   	div.navigation-wrapper{
   		width: 100%;
   		height: 48px;
   		line-height: 48px;
   		background-color: #282828;
		&.hover-bg{
		  background-color:#424242;
		}
   		div.navigation{
   			width: 1200px;
   			margin: 0 auto;
   			*zoom: -1;
   			@include clearboth;
   			position: relative;
   			div.navigation-left{
   				float: left;
   				a{
   					display: block;
   					height: 100%;
   					float: left;
   					padding-left: 20px;
   					padding-right: 20px;
   					font-size: 16px;
   					color: #FFFFFF;
   					-webkit-transition: all 5s;
					-moz-transition: all 5s;
					-ms-transition: all 5s;
					-o-transition: all 5s;
					transition: all 5s;
					&:hover{
						background: url(~images/icon_navbg.png) no-repeat center center;
						@include linear-gradient(right, #ff3c42, #ff643a);
						-webkit-transition: all 5s;
						-moz-transition: all 5s;
						-ms-transition: all 5s;
						-o-transition: all 5s;
						transition: all 5s;
						&.softActive{
							position: relative;
							&:after{
								width: 15px;
								height: 8px;
								display: block;
								content: '';
								position: absolute;
								left: 50%;
								margin-left: -8px;
								bottom: 0;
								background: url(~images/nav_arrow.png) no-repeat center top;
								z-index: 999;
							}
						}
					}
   					&.active{
   						background: url(~images/icon_navbg.png) no-repeat center center;
						@include linear-gradient(right, #ff3c42, #ff643a);
						&.softActive{
							position: relative;
							&:after{
								width: 15px;
								height: 8px;
								display: block;
								content: '';
								position: absolute;
								left: 50%;
								margin-left: -8px;
								bottom: 0;
								background: url(~images/nav_arrow.png) no-repeat center top;
								z-index: 999;
							}
						}
   					}
   				}
   			}
   			div.navigation-right{
   				float: right;
   				font-size: 14px;
   				a{
   					display: block;
   					color: #FFFFFF;
   					float: right;
   					padding-left: 11px;
   					// padding-right: 11px;
   					-webkit-transition: color .4s;
					-moz-transition: color .4s;
					-ms-transition: color .4s;
					-o-transition: color .4s;
					transition: color .4s;
   					&:hover{
   						color: #ff3c42;
   						-webkit-transition: color .4s;
						-moz-transition: color .4s;
						-ms-transition: color .4s;
						-o-transition: color .4s;
						transition: color .4s;
   					}
   				}
   			}
   			div.nav-detail-box{
                width: 100%;
                background-color: $color-title;
                color: #333333;
                position: absolute;
                top: 48px;
                left: 0;
			    z-index: 999;
                text-align: left;
                line-height: 1;
                font-size: 14px;
                @include boxshadow(0,3px,15px,rgba(154,154,154,0.3));
                -webkit-border-bottom-left-radius: 4px;
                -moz-border-radius-bottomleft: 4px;
                border-bottom-left-radius: 4px;
                -webkit-border-bottom-right-radius: 4px;
                -moz-border-radius-bottomright: 4px;
                border-bottom-right-radius: 4px;
                div.nav-detail-contain{
                    width: 1200px;
                    margin: 1px auto 0;
                    overflow: hidden;
                    padding: 31px 30px 31px 40px;
                >ul{
                    float: left;
                    overflow: hidden;
					&.sub-ul{
						float: none;
					}
                    >li{
                        width: 120px;
                       float: left;
					   margin-right: 20px;
					   >div{
							font-weight:bold;
						}
                       &:nth-child(4){
                           width: 150px;
                       }
                       &:last-child{
                           width: 100px;
                       }
                       &.item-specail{
                           width: 260px;
                           >ul{
                               position: relative;
                               li{
                                   &:last-child{
                                       position: absolute;
                                       right: 61px;
                                       top: -24px;
                                   }
                               }
                           }
                       }
                       >div{
                           position: relative;
                           padding-bottom: 11px;
						   a{
                            font-weight: bold;
							&:hover{
								color:$hover-color;
							}
						   }
                           &:after{
                               display: block;
                               content: '';
                               width: 30px;
                               height: 3px;
                               background-color: $red-color;
                               position: absolute;
                               left: 0;
                               bottom: 0;
                           }
                       }
					   &.hasThirdSubItem{
						   width:auto!important;
						   margin-right: 0;
						   &:last-child{
							   float: right;
						   }
						   >ul{
							   overflow: hidden;
                           >li{
							  float: left;
							  min-width: 100px;
							  &.hasThirdSub{
								  >a{
									  font-weight: bold;
									  display: block;
									  width: 100%;
									  clear: both;
								  }
								  >ul{
									  float: left;
									  margin-top: 24px;
									  >li{
                                         margin-bottom: 24px;
										 padding-left: 11px;
										 padding-right: 30px;
										 background: url(~images/sub_sub_icon.jpg) no-repeat left center;
										 &:last-child{
											 margin-bottom: 0;
										 }
									  }
								  }
							  }
                           }
                       }

					   }
                       >ul{
                           >li{
                              margin-top: 24px;
                              a{
                                 &:hover{
                                  color: $hover-color;
                                 }
                              }
                           }
                       }
                    }
                }
                >div{
                    float: right;
					margin-right: 30px;
					&:nth-child(2){
						margin-right: 0;
					}
                    img{
                        width: 280px;
                        height: 175px;
                    }
                }
                }
            }
            ul.study-subpage-box{
            	width: 80px;
                background-color: $color-title;
                color: #333333;
                position: absolute;
                top: 48px;
                left: 0;
			    z-index: 999999;
                text-align: center;
    			line-height: 23px;
                font-size: 14px;
                padding-top: 20px;
                padding-bottom: 20px;
                @include boxshadow(0,3px,15px,rgba(154,154,154,0.3));
                -webkit-border-bottom-left-radius: 4px;
                -moz-border-radius-bottomleft: 4px;
                border-bottom-left-radius: 4px;
                -webkit-border-bottom-right-radius: 4px;
                -moz-border-radius-bottomright: 4px;
                border-bottom-right-radius: 4px;
                li{
                	margin-bottom: 18px;
                	&:last-child{
						margin-bottom: 0;
					}
					a{
						display: block;
						width: 100%;
						height: 100%;
						&:hover{
							color: #ff3c42;
						}
					}
                }
            }
            div.study-box{
            	ul{
            		left: 244px;
            	}
            }
            div.lilong-box{
            	ul{
            		left: 332px;
            	}
            }
   		}
   	}
   	&.fixed-header{
   		display: none;
   		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
		width: 100%;
		height: 60px;
		@include boxshadow(0,0,15px,rgba(154,154,154,0.3));
		div.cwrap {
		    margin: 0 auto;
		    width: 1200px;
		    div.logo {
			    float: left;
			    padding-top: 14px;
			    width: 160px;
			    img {
				    width: 120px;
				}
			}
			ul.nav {
			    float: left;
			    width: 652px;
			    font-size: 16px;
			    li{
				    float: left;
				    margin-right: 13px;
				    line-height: 60px;
				    a{
				    	color: $color-text;
				    	@include transitions(.4s);
				    	&:hover{
				    		color: $hover-color;
				    	    @include transitions(.4s);
				    	}
				    }
				    &.active{
				    	a {
						    color: $hover-color;
						}
				    }
				}
			}
			div.head-search {
				float: left;
			    padding-top: 11px;
			    width: 220px;
			    height: 60px;
			}
			div.my-account-link {
				font-size: 16px;
			    float: right;
			    line-height: 1.5;
			    margin-top: 18px;
			    padding-left: 30px;
			    width: 158px;
			    border-left: 1px solid #cdcdcd;
			    background: url(~images/my-acc.png) 5px center no-repeat;
			    a{
			    	color: $color-text;
			    	@include transitions(.4s);
			    	&:hover{
			    		 color: $hover-color;
			    	}
			    }
			}
		}

   	}
   }
</style>



// WEBPACK FOOTER //
// src/components/top.vue